module.exports = __webpack_public_path__ + "media/greeting_cakes.07b23712.mp4";